import { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { LoadingSpinner } from "./components/custom-ui/loading.spinner";
import { ThemeProvider } from "./components/ui/theme.provider";
import { useUserStore } from "./store/user";

function App() {
  const checkAuth = useUserStore((store) => store.checkAuth);
  const isLoading = useUserStore((store) => store.isLoading);

  useEffect(() => {
    const auth = async () => {
      const accessToken = useUserStore.getState().getAccessToken();
      if (accessToken) {
        await checkAuth();
      }
    };
    auth();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen">
        <div className="min-h-screen flex justify-center items-center">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  return (
    <ThemeProvider defaultTheme="light" storageKey="champ-ui-theme">
      <Suspense
        fallback={
          <div className="min-h-screen flex justify-center items-center">
            <LoadingSpinner />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
